import {StyleSheet} from 'react-native';

import {darkGray, grayscale, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    paddingTop: 20,
  },
  title: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  infoIcon: {
    color: grayscale,
  },
  titleText: {
    flex: 1,
    minWidth: 0,
    color: darkGray,
  },
  icon: {
    color: 'black',
  },
});
